import React from 'react';
import '../../styles/CarelonRx/modal.css';

interface CancelChangePasswordModalProps {
  show: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}

const CancelChangePasswordModal: React.FC<CancelChangePasswordModalProps> = ({
  show,
  onDismiss,
  onConfirm
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="modal-title">Are you sure you want to cancel?</h2>
        <p className="modal-description">
          If you cancel, you won't be able to create a new password and log in.
        </p>
        <div className="modal-actions">
          <button onClick={onDismiss} className="modal-btn-cancel">
            No, Don't Cancel
          </button>
          <button onClick={onConfirm} className="modal-btn-stay">
            Yes, Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelChangePasswordModal;
